<div class="benfits-plus-lobby">

    <div class="bread-crumbs">
        <a title="" [href]="benefitsLink">הטבות | </a>
        <a *ngIf="benefitsSvc.type" title="" routerLink="/benefits/bizplus" (click)="resetFilters()">הטבות פלוס | </a>
        <span aria-current="page" *ngIf="!benefitsSvc.type">הטבות פלוס</span>
        <span aria-current="page" *ngIf="benefitsSvc.type">{{benefitsSvc.type.typeName}}</span>
    </div>

    <div class="title-wrapper" [ngStyle]="{background: data?.image?.url ? 'url(' + data.image.url + ')no-repeat' : null}">
        <h1 *ngIf="data?.title">{{data.title}}</h1>
        <h2 *ngIf="data?.subtitle">{{data.subtitle}}</h2>
    </div>

    <app-benefits-plus-filters [data]="data" (loadBenefits)="loadFromFilters($event)"></app-benefits-plus-filters>

    <div class="content" [ngClass]="{filtered: !showPromoted}">
        <div class="main-wrapper">
            <h1 aria-level="3" *ngIf="showPromoted && data?.promotedBenefitsTitle && promotedBenefits?.length">{{data.promotedBenefitsTitle}}</h1>
            <app-promoted-benefits *ngIf="showPromoted" [promotedBenefits]="promotedBenefits" (openBenefit)="openBenefit($event)"></app-promoted-benefits>

            <div class="all-discounts" [ngClass]="{filtered: !showPromoted}">
                <h1 aria-level="4" *ngIf="data?.allBenefitsTitle">{{showPromoted ? data.allBenefitsTitle : (benefitsSvc.type?.typeName ? benefitsSvc.type.typeName : '') + (benefitsSvc.region?.name ? ' ב' + benefitsSvc.region.name : '')}}</h1>
                <h5 role="presentation" *ngIf="!showPromoted">נמצאו {{total}} הנחות במעמד החיוב</h5>
                <app-all-benefits *ngIf="allBenefits?.length" [benefits]="allBenefits" (openBenefit)="openBenefit($event)"></app-all-benefits>
            </div>

            <div u1-button class="load-more-discounts" *ngIf="allBenefits?.length && isShowMore && data?.moreBenefitsText"
                (click)="gtmService.pushNewBenefitPulsePageLobby('Click on more benefits');
                loadBenefits({
                type: this.benefitsSvc.type,
                region: this.benefitsSvc.region,
                sort: this.benefitsSvc.sort
            })">{{data.moreBenefitsText}}</div>
        </div>
    </div>
</div>

